import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import * as Objects from '@core/objects';
import { SearchFilterMenuItem } from '@app/components/helpers/search/filters/models/filters-menu';
import { SearchAppliedFilter, SearchAvailableFilters } from '@app/models/search';

import { LogbookFiltersService, LogbookSearchService } from '@app/services/app/logbook.service';

@Component({
    selector: 'projects-logbook-search-filters',
    templateUrl: './filters.component.html',
    styleUrls: ['./filters.component.scss']
})
export class ProjectsLogbookSearchFiltersComponent implements OnInit, OnDestroy {

    public readonly STATUS_LOADING = 0;
    public readonly STATUS_DONE = 1;
    public readonly STATUS_NOT_ALLOWED = 2;

    public status: number = 0;
    private wasInside: boolean = false;

    public selectedFilter: string = '';

    // menu
    public filtersMenu: Array<SearchFilterMenuItem> = [
        {
            title: 'Filter by Event',
            key: 'event',
            order: 1
        },{
            title: 'Filter by User',
            key: 'user',
            order: 2
        }
    ];

    public availableEvents: SearchAvailableFilters = null;
    // public availableOwners: SearchAvailableFilters = null;
    public availableUsers: SearchAvailableFilters = null;
    public appliedFilters: SearchAppliedFilter[] = [];

    private usersSubscription: Subscription;
    private eventsSubscription: Subscription;
    private appliedFiltersSubscription: Subscription;

    @HostListener('click')
    clickInside() {
        this.wasInside = true;
    }
  
    @HostListener('document:click')
    clickout() {
        if (!this.wasInside) {
            this.selectedFilter = '';
        }
        this.wasInside = false;
    }

	constructor(
        private filtersSrv: LogbookFiltersService,
        private searchSrv: LogbookSearchService
    ){}

	ngOnInit(){

        this.usersSubscription = this.filtersSrv.selectUsers().subscribe((filter: SearchAvailableFilters) => this.availableUsers = filter);
        this.eventsSubscription = this.filtersSrv.selectEvents().subscribe((filter: SearchAvailableFilters) => this.availableEvents = filter);

        this.appliedFiltersSubscription = this.searchSrv.selectFilters().subscribe((filters: SearchAppliedFilter[]) => this.appliedFilters = filters);
       
    }

    ngOnDestroy() {
        this.usersSubscription.unsubscribe();
        this.eventsSubscription.unsubscribe();
        this.appliedFiltersSubscription.unsubscribe(); //TODO
    }

    onSelectFilter(key: string){
        this.selectedFilter = key;
    }

    onApplyFilter(filter: SearchAppliedFilter){
        this.searchSrv.applyFilter(filter); // TODO
    }

}
